<template>
  <div>
    <div class="p-question-list">
      <CommonHeader class="common-header">{{ $t('rank.name') }}</CommonHeader>
      <!-- Question navs. -->
      <nav class="nav">
        <RouterLink
          :to="navRouterLinkBuilder('question')"
          replace
          exact
          exact-active-class="active"
        >
          {{ $t('rank.question_star') }}
        </RouterLink>
        <RouterLink
          :to="navRouterLinkBuilder('feeds')"
          replace
          exact
          exact-active-class="active"
        >
          {{ $t('rank.share_star') }}
        </RouterLink>
        <RouterLink
          :to="navRouterLinkBuilder('follow')"
          replace
          exact
          exact-active-class="active"
        >
          {{ $t('rank.most_follow') }}
        </RouterLink>
        <RouterLink
          :to="navRouterLinkBuilder('month')"
          replace
          exact
          exact-active-class="active"
        >
          {{ $t('rank.month_question_start',[currentMonth]) }}
        </RouterLink>
        <RouterLink
          :to="navRouterLinkBuilder('year')"
          replace
          exact
          exact-active-class="active"
        >
          {{ $t('rank.years_question_start') }}
        </RouterLink>
        <RouterLink
          :to="navRouterLinkBuilder('active')"
          replace
          exact
          exact-active-class="active"
        >
          {{ $t('rank.most_active_group') }}
        </RouterLink>
      </nav>

      <!-- Question main. -->
      <main class="main">
        <div v-if="loading" class="main-loading">
          <IconLoading class="main-loading_icon" />
        </div>
        <div
          v-for="(item,index) in list"
          :key="item.id"
          class="group-item-wrap"
        >
          <GroupItem
            v-if="type === 'active'"
            :group="item"
            :index="index"
            :show-action="true"
          />

          <RankListItem
            v-else
            :key="item.id"
            :prefix-cls="prefixCls"
            :user="item"
            :index="index"
            :show-index="true"
          >
            <div class="base-info">
              <div>{{ item.office }} - {{ item.department }}</div>
              <div>{{ item.title }}</div>
            </div>
            <div class="tags">
              <div v-for="(tag,ind) in item.tags_show.slice(0,3)" :key="tag.name+ind">
                <span class="tag-name">{{ tag.name }}</span>
                <span v-if="ind < 2 && ind < item.tags_show.length-1" class="dot">·</span>
              </div>
            </div>
          </RankListItem>
        </div>

        <!-- <div v-if="users.length && !loadmore" class="main-loadmore">
          <button class="main-loadmore_button" @click="fetchMore">
            {{ $t('loadmore.bottom[2]') }}
          </button>
        </div> -->

        <!-- <div v-else-if="loadmore" class="main-loadmore">
          <button class="main-loadmore_button active">
            <IconLoading class="main-loading_icon" />
          </button>
        </div> -->
      </main>
    </div>
  </div>
</template>

<script>
  import LinearLoading from '@/icons/LinearLoading.vue'
  import RankListItem from '../components/RankUsersComponent2.vue'
  import { getRankUsers } from '@/api/ranks'
  import GroupItem from '@/components/GroupItem'
  const prefixCls = 'rankItem'
  export default {
    name: 'QuestionList',
    components: {
      GroupItem,
      RankListItem,
      IconLoading: LinearLoading,

    },
    data () {
      return {
        prefixCls,
        loading: false,
        loadmore: false,
        list: [],
        currentType: '',
        currentMonth: (new Date()).getMonth() == 0 ? 12 : (new Date()).getMonth(),
      }
    },
    computed: {
      type () {
        const { type = 'question' } = this.$route.query
        return type
      },
    },
    watch: {
      $route (to, from) {
        if (
          (to.path === from.path && to.query.type !== from.query.type) ||
          !from.query.type // 后退再进入时重新拉取数据
        ) { this.fetch() }
      },
    },
    mounted () {
      this.fetch()
    },
    methods: {
      /**
       * Nav router link builder.
       *
       * @param {string} type
       * @return {Object}
       * @author Seven Du <shiweidu@outlook.com>
       */
      navRouterLinkBuilder (type) {
        return {
          path: '/rank/list',
          query: {
            type,
          },
        }
        // return {
        //   path: '/question',
        //   query: { type },
        // }
      },

      /**
       * Fetch question method.
       *
       * @return {void}
       * @author Seven Du <shiweidu@outlook.com>
       */
      fetch () {
        this.loading = true
        this.list = []
        // getRankList({ type: this.type })
        getRankUsers(`/ranks?type=${this.type}`)
          .then((data) => {
            this.list = data
            this.loading = false
          })
          .catch(({ response: { data } = {} }) => {
            this.loading = false
          })
      },

      fetchMore () {
        // this.loadmore = true
        // this.list = []
        // getRankList({ type: this.type })
        // getRankUsers('/ranks/followers', { offset: this.list.length || 0 })
        //   .then(({ data }) => {
        //     this.loadmore = false
        //     if (!data.length) return

        //     this.list = [...this.list, ...data]
        //   })
        //   .catch(({ response: { data } = {} }) => {
        //     this.loadmore = false
        //   })
      },
    },
  }
</script>

<style lang="less" scoped>
.p-question-list {
  // padding-top: 180px;
  padding-bottom: 100px;
  min-height: 100vh;
  background-color: #fff;;

  .nav {
    position: fixed;
    top: 90px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    max-width: 768px;
    height: 90px;
    background: #fff;
    color: #999;
    font-size: 30px;
    border-bottom: solid 1px #dedede; /* no */
    z-index: 10;

    > a {
      color: #999;
      font-size: 24px;
      display: inline-block;
      padding-top: 30px;
    }

    .active {
      color: @tool-bar-bg;
      font-weight:500;
      position: relative;
      &:after {
        content:' ';
        width: 56px;
        height: 4px;
        display: inline-block;
        position: absolute;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
        background-color: @tool-bar-bg;
      }
    }
  }

  .main {
    padding-top: 180px;
    .main-loading {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 24px;

      &_icon {
        width: 120px;
        height: 30px;
        fill: #58b6d7;
      }
    }
    .base-info {
      color: #999;
      font-size:20px;
      margin: 6px 0;
    }
    .main-loadmore {
      margin: 24px auto;
      text-align: center;

      &_button {
        padding: 12px 24px;
        color: #58b6d7;
        background-color: transparent;
        border: solid 1px #58b6d7; /* no */
        border-radius: 6px;
        outline: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;

        &.active {
          color: #aaa;
          border: none;
        }
      }
    }
  }

  .create-question {
    position: fixed;
    bottom: 40px;
    right: 40px;
    height: 60px;
    width: 60px;
    padding: 0;
    border-radius: 100%;
    background-color: @primary;
    border: 2px solid #fff; /* no */
    box-shadow: 0px 0px 12px 0px rgba(89, 182, 215, 0.43);
    z-index: 1;

    > svg {
      display: block;
      margin: auto;
      color: #fff;
    }
  }
  .types {
    padding: 27px 33px;
    background-color: #fff;
    overflow-y: auto;
    white-space: nowrap;
    font-size:24px;
    > div{
      display: inline-block;
      padding: 10px 22px;
      background-color: #F5F5F5;
      color: #666;
      margin: 0 10px;
      border-radius:8px;
      &.active {
        color:#fff;
        background-color: #00AEEF;
      }
    }
  }
  .nav {
    white-space: nowrap;
    overflow: auto;
    max-width: 100vw;
    display: block;
    a {
      margin: 0 20px;
    }
  }
  .common-header {
    position: fixed;
    background-color: #1a1a1a;
    color: #fff;
  }
  .tags {
    > div {
    font-size: 24px;
    display: inline-flex;
    color: #3283a2;

  }
  .dot {
    color: @text-color3;
    display: inline-block;
    margin:0 10px;
  }
  .tag-name {
      display: inline-block;
      white-space: nowrap;
      max-width: 180px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;
  }
  }
}
</style>

<style scoped>
.group-item-wrap {
  padding: 0 20px;
}
.group-item-wrap >>> .follow-btn{
  font-size: 24px;
  padding: 7px 15px !important;
  width: auto !important;
  /* background-color: #fff; */
}
.group-item-wrap >>> .c-group-item {
  padding: 30px 0;
  border-bottom: 1px solid #E5E5E6;
}
</style>
